import { call, put, select, takeLatest } from 'redux-saga/effects';
import { priceActions as actions } from '.';
import {
  selectCustomerNumber,
  selectLanguageId,
} from 'app/features/erpSystem/slice/selectors';
import { erpalPayloadDTO } from './utils';
import { PriceDataResponse } from './types';
import { PayloadAction } from '@reduxjs/toolkit';
import { selectStoreId } from 'app/features/salesOrganisation/slice/selectors';

export function* fetchPriceData(action: PayloadAction<any>): any {
  const { getPriceDataSuccess, getPriceDataFail } = actions;

  try {
    const customerNumber = yield select(selectCustomerNumber);
    const languageId = yield select(selectLanguageId);
    const storeId = yield select(selectStoreId);

    const itemsTransformed = yield erpalPayloadDTO(action.payload);
    const shopId = storeId % 10; // Get last digit of store id Ex: 100001  => 1

    const itemsPriceResponse = yield call(
      fetch,
      `/valve-configurator/api/price?customerNumber=${customerNumber}&shopId=${shopId}&currency=EUR&languageId=${languageId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(itemsTransformed),
      },
    );

    if (itemsPriceResponse.status !== 200) {
      return yield put(getPriceDataFail('failed to fetch'));
    } else {
      const itemsPriceData: PriceDataResponse = yield itemsPriceResponse.json();

      if (!itemsPriceData) {
        return yield put(getPriceDataFail('No prices fetched'));
      }

      return yield put(getPriceDataSuccess(itemsPriceData));
    }
  } catch (e) {
    yield put(getPriceDataFail(e));
  }
}
export function* priceSaga() {
  yield takeLatest(actions.getPriceData.type, fetchPriceData);
}
